// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"data-search"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M3 3H21V12H3V3Z"}},{"tag":"path","attrs":{"id":"fill2","fill":"props.fillColor2","d":"M21.5 18.25C21.5 19.7688 20.2688 21 18.75 21C17.2312 21 16 19.7688 16 18.25C16 16.7312 17.2312 15.5 18.75 15.5C20.2688 15.5 21.5 16.7312 21.5 18.25Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M3 12H21V3H3V12ZM3 12L3 21.0004H12.5M3 12V11.998M6.99805 7.5H7.00195V7.50391H6.99805V7.5ZM6.99805 16.5H7.00195V16.5039H6.99805V16.5Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M22.25 21.75L20.6945 20.1945M21.5 18.25C21.5 19.7688 20.2688 21 18.75 21C17.2312 21 16 19.7688 16 18.25C16 16.7312 17.2312 15.5 18.75 15.5C20.2688 15.5 21.5 16.7312 21.5 18.25Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const DataSearchIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'data-search',
    ref,
    icon: element,
  },
));

DataSearchIcon.displayName = 'DataSearchIcon';

export default DataSearchIcon;
